//
// social-index/helpers.js
//

const stylevars = require('../../../core/js/StyleVariables');

// mq_list - listen for responsive state changes
// ----------------------------

const mq_list = matchMedia(`(max-width: ${stylevars.bp_max.md})`);


// fuzzy name matching for index and company names/urls
// ----------------------------
// - NB. if you want fuzzy matching on spaces between words:
//     index_name    - version with spaces
//     test_name     - url slug or name possibly without spaces
//

function name_matches(index_name, test_name) {
  if (!index_name || !test_name) {
    return false;
  }

  test_name = test_name.replace('(', '\\(');
  test_name = test_name.replace(')', '\\)');
  test_name = test_name.replace(/[-  ]/gi, '[-  ]?');
  test_name = new RegExp(`^${test_name}$`, 'i');

  return index_name.match(test_name);
}


// find an index property -> requested property / null
// ----------------------------

function find_index_prop(index_name, prop) {
  let index;
  call_for_matching_index(index_name, (si) => index = si[prop]);
  return index;
}


// find group object from group name
// ----------------------------

function find_group(group_name) {
  return window.social_index_data.find(g => g['group-name'] === group_name);
}


// find indexes for group
// ----------------------------

function indexes_for_group(group_name) {
  let g = find_group(group_name);
  return g ? g['group-items'] : null;
}


// call supplied function for index matching name or url - cb: f(index_name, group_object)
// ----------------------------

function call_for_matching_index(index_name_or_url, f) {
  let groups = window.social_index_data;

  groups.forEach(function(g) {
    let matching_index =
      g['group-items'].find(si => name_matches(si['name'], index_name_or_url)) ||
      g['group-items'].find(si => si['slug'] === index_name_or_url);

    if (matching_index) {
      f(matching_index, g);
      return;
    }
  });
}


// cb_after_anim() - run cb after an animation has completed
// ----------------------------

function cb_after_anim(el, cb) {
  let test_el = document.createElement('fakeelement');
  const animations = {
    'animation': 'animationend',
    'OAnimation': 'oanimationend',
    'MozAnimation': 'animationend',
    'WebkitAnimation': 'webkitAnimationEnd',
    'MsAnimationEnd': 'msAnimationEnd',
  };

  function get_event_name() {
    for (let t in animations) {
      if (test_el.style[t] !== undefined) {
        return animations[t];
      }
    }
  }

  el.addEventListener(get_event_name(), function(e) {
    if (e.target === el) {
      cb();
    }
  }, false);
}


let SORT_ASC  = 0;
let SORT_DESC = 1;


module.exports = {
  name_matches,
  find_index_prop,
  find_group,
  indexes_for_group,

  mq_list,

  cb_after_anim,

  SORT_ASC,
  SORT_DESC,
  invert_sort : function(sort) {
    return sort === SORT_ASC ? SORT_DESC : SORT_ASC;
  },
};
